import type { TRuleWithTheme } from '@/styles/theme';

export const divider: TRuleWithTheme = ({ theme }) => ({
    borderBottom: `1px solid ${theme.colors.foregroundsSeparator}`,

    min768: {
        marginLeft: theme.spacing(40),
        marginRight: theme.spacing(40),
    },
});
